"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var Colors_1 = require("@CommonFrontend/Styles/Colors");
var Types_1 = require("../Types");
var GAP_HEIGHT = 1;
var DEFAULT_COLOR = Colors_1.ColorPalette.Purple;
var c = (0, BemBuilder_1.default)("chart-custom__shape__wave");
var BG_OPACITY_MAPPING = (_a = {},
    _a[Types_1.BarShapeActiveStatus.Active] = 0.7,
    _a[Types_1.BarShapeActiveStatus.Inactive] = 0.2,
    _a[Types_1.BarShapeActiveStatus.Standard] = 0.5,
    _a);
var WAVE_OPACITY_MAPPING = (_b = {},
    _b[Types_1.BarShapeActiveStatus.Active] = 1,
    _b[Types_1.BarShapeActiveStatus.Inactive] = 0.2,
    _b[Types_1.BarShapeActiveStatus.Standard] = 0.8,
    _b);
var getBackgroundPath = function (x, y, width, height) { return "M".concat(x, ",").concat(y, "\n  h").concat(width, "\n  v").concat(height, "\n  h-").concat(width, "\n  Z\n"); };
function BarWaveShape(props) {
    var payload = props.payload, x = props.x, y = props.y, width = props.width, height = props.height, activeStatus = props.activeStatus;
    var fillColor = payload.color || DEFAULT_COLOR;
    if (height === 0)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { d: getBackgroundPath(x, y, width, GAP_HEIGHT), fill: "#fff" }),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("pattern", { id: "wavy-".concat(fillColor), x: "0", y: "0", width: "100", height: "20", patternUnits: "userSpaceOnUse" },
                react_1.default.createElement("path", { fill: fillColor, opacity: WAVE_OPACITY_MAPPING[activeStatus], d: "M21.184 20c.357-.13.72-.264 1.088-.402l1.768-.661C33.64 15.347 39.647 14 50 14c10.271 0 15.362 1.222 24.629 4.928.955.383 1.869.74 2.75 1.072h6.225c-2.51-.73-5.139-1.691-8.233-2.928C65.888 13.277 60.562 12 50 12c-10.626 0-16.855 1.397-26.66 5.063l-1.767.662c-2.474.923-4.66 1.674-6.724 2.275h6.335Zm0-20C13.257 2.892 8.077 4 0 4V2c5.744 0 9.951-.574 14.85-2h6.334ZM77.38 0C85.239 2.966 90.502 4 100 4V2c-6.842 0-11.386-.542-16.396-2h-6.225ZM0 14c8.44 0 13.718-1.21 22.272-4.402l1.768-.661C33.64 5.347 39.647 4 50 4c10.271 0 15.362 1.222 24.629 4.928C84.112 12.722 89.438 14 100 14v-2c-10.271 0-15.362-1.222-24.629-4.928C65.888 3.278 60.562 2 50 2 39.374 2 33.145 3.397 23.34 7.063l-1.767.662C13.223 10.84 8.163 12 0 12v2Z" }))),
        react_1.default.createElement("rect", { x: x, y: y + 1, width: width, height: height, fill: fillColor, opacity: BG_OPACITY_MAPPING[activeStatus] }),
        react_1.default.createElement("rect", { x: x, y: y + 1, width: width, height: height - GAP_HEIGHT, fill: "url(#wavy-".concat(fillColor, ")") })));
}
exports.default = BarWaveShape;
